<template>
	<div class="data-container">
<!--		<el-switch-->
<!--		  style="margin-bottom: 15px;"-->
<!--		  v-model="switchval"-->
<!--		  active-text="图标"-->
<!--		  inactive-text="表格">-->
<!--		</el-switch>-->
		<!-- 如果 switchval 为真，则显示 Devicedoorrecordecharts 组件 -->
		<DeviceDoorRecordEcharts :deviceId="deviceId" v-if="switchval"/>

		<!-- 如果 switchval 为假，则显示 Devicedoorrecordtable 组件 -->
		<DeviceDoorRecordTable :deviceId="deviceId" v-else/>
	</div>
</template>

<script>
import *as echarts from 'echarts'

import DeviceDoorRecordEcharts from "@/views/components/Devicedoorrecordecharts.vue";
import DeviceDoorRecordTable from "@/views/components/Devicedoorrecordtable.vue";

export default {
	name: "DeviceDoorRecord",
	components: {DeviceDoorRecordEcharts, DeviceDoorRecordTable},
	props:{
		deviceId: {
			validator: null // 禁用类型检查
		}
	},
	data() {
		return {
			// switch
			switchval: false,

			// select 选择
			options: [{
				value: '1',
				label: '当日'
			}, {
				value: '2',
				label: '最近一周',
			}, {
				value: '3',
				label: '最近30天',
			}],
			value: '1',

			option: {
				title: {
					text: 'Step Line',
					left: 'center',
				},
				tooltip: {
					trigger: 'axis'
				},
				// legend: {
				// 	data: ['Step Start', 'Step Middle', 'Step End']
				// },
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: 'Step Start',
						type: 'line',
						step: 'start',
						data: [0, 1, 0, 1, 1, 1, 0]
					},
				]
			}
		}
	},
	mounted() {
		this.drawLine();
	},
	methods: {
		drawLine() {
			const myChart = echarts.init(document.getElementById("Devicedoorrecord"));
			myChart.setOption(this.option);
		}
	}
}
</script>

<style scoped>
.chart {
	height: 400px;
	width: 100%;
}

.date-select {
	width: 100px;
	position: absolute;
	left: 5%;
	z-index: 10;
}

.data-container {
	margin: 15px;
	padding: 15px;
	border: 1px solid #EBEEF5;
	border-radius: 2px;
	position: relative;
}
</style>